import React, { Fragment } from 'react'
import styled, { withTheme } from 'styled-components'
import skeletonFade from '../../../../../../modules/mixins/skeleton-fade'
import TextSkeleton, { Line0TextSkeleton } from '../../../../../../components/Text/views/TextSkeleton'
import { ContainerQuery } from 'react-container-query'

const StyledTextSkeleton = styled(TextSkeleton)`
  ${Line0TextSkeleton} {
    border-width: 10px;
  }
`

const StyledTitleSkeleton = styled(TextSkeleton)`
  ${Line0TextSkeleton} {
    border-width: 20px;
  }
  margin-bottom: 10px;
`

const TextWrapper = styled.div`
  flex: 1;
  margin-left: 30px;
  margin-top: 20px;
  margin-right: 10px;
`

const ImageSkeleton = styled.div`
  background-color: ${(props) => props.theme.color.skeletonScreen};
  ${skeletonFade};
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  font-size: ${(props) => props.theme.fontSize.base};
  width: ${(props) => props.theme.sizes.col6};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.base};
    width: ${(props) => props.theme.tablet.sizes.col6};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.base};
    width: ${(props) => props.theme.mobile.sizes.col6};
  }
  @media (min-width: ${(props) => props.theme.breakPoint + 'px'}) {
    max-width: 300px;
    width: 300px;
    padding-top: 168.75px;
  }
  padding-top: 27.5%;
  ${skeletonFade}
`

const Wrapper = styled.div`
  display: flex;
  margin: ${(props) => props.margin};
  @media (max-width: 450px) {
    margin-right: 0;
    margin-left: 0;
  }
`

const containerQuery = {
  mobile: {
    maxWidth: 739,
  },
  noText: {
    maxWidth: 600,
  },
}

const SkeletonSmallLandscapeItemArticle = ({ margin, ...props }) => (
  <ContainerQuery query={containerQuery}>
    {(themeMode) => (
      <Wrapper margin={margin}>
        <Fragment>
          <ImageSkeleton />
          <TextWrapper>
            <StyledTitleSkeleton lines={themeMode.noText ? 2 : themeMode.mobile ? 1 : 2} />
            <StyledTextSkeleton lines={themeMode.noText ? 0 : themeMode.mobile ? 3 : 4} lastWidth="50%" />
          </TextWrapper>
        </Fragment>
      </Wrapper>
    )}
  </ContainerQuery>
)

SkeletonSmallLandscapeItemArticle.defaultProps = {
  margin: '0',
}

export default withTheme(SkeletonSmallLandscapeItemArticle)
export { Wrapper as Wrapper0SkeletonSmallLandscapeItemArticle }
